export enum NotificationContentType {
  Text,
  Html,
}
